// extracted by mini-css-extract-plugin
export default {"ellipsisContainer":"TopEllipsis_ellipsisContainer__ibNMS","ellipsis":"TopEllipsis_ellipsis__2nOuA"};